import { Box, Divider, Paper, Tab, Tabs, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import SubscriptionBarChart from "./SubscriptionBarChart";
import { useTranslation } from "react-i18next";

const tabLabels = ["worker", "company", "supplier"];

function MothlySubscriptionReport({ chartData }) {
  const { t } = useTranslation(["report", "common"]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [filterDaa, setFilterData] = useState([]);

  useEffect(() => {
    let filter = chartData.filter(
      (x) => x.userType?.toLowerCase() === tabLabels[selectedTab]?.toLowerCase()
    );
    setFilterData(filter);
  }, [chartData]);

  const handleTabChange = (event, newValue) => {
    let filter = chartData.filter(
      (x) => x.userType?.toLowerCase() === tabLabels[newValue]?.toLowerCase()
    );
    setFilterData(filter);
    setSelectedTab(newValue);
  };
  return (
    <Paper sx={{ borderRadius: "8px", overflow: "hidden", height: 450 }}>
      <Typography variant="h6" fontWeight={600} p={2}>
        {t("monthlySubscriptionReport")}
      </Typography>
      <Divider />
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="fullWidth"
        textColor="primary"
        indicatorColor="primary"
        sx={{
          "& .MuiTabs-indicator": {
            backgroundColor: "#1976d2",
          },
        }}
      >
        {tabLabels.map((label, index) => (
          <Tab key={index} label={t(label)} />
        ))}
      </Tabs>
      <Divider />
      <Box
        p={2}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 350,
        }}
      >
        {filterDaa.length === 0 ? (
          <Typography variant="body1">{t("noDataAvailable", { ns: "common" })}</Typography>
        ) : (
          // <></>
          <SubscriptionBarChart
            key={selectedTab}
            chartData={filterDaa}
            // data={getChartDataForTab(selectedTab)}
          />
        )}
      </Box>
    </Paper>
  );
}

export default MothlySubscriptionReport;
